import React from 'react';
import clx from 'classnames';
import './FooterFront.scss';
import { useThemeConfig } from 'client/components/schema/config/ClientConfigModule';
import { MicFooterFront } from './mic/MicFooterFront';

export interface FooterFrontProps {}

/**
 * Container del Footer delle pagine pubbliche
 * Definisce la larghezza massima del contenuto della pagina.
 */
export function FooterFront(props: FooterFrontProps) {
  const { labels } = useThemeConfig();
  const staticFooterName = labels.staticFooterName;

  switch (staticFooterName) {
    case 'mic':
      return <MicFooterFront className="footer-front" />;
    default:
      return null;
  }
}
